export default __webpack_public_path__ + "static/about-your-job-header-14807070ab0c7f75fdf1c82502a040a2.png";